export let base_state = {
    items: [],
    updated_at: false,
    project_id: false,
    fetching: false,
    refresh_timeout: null
}